import { useMemo } from "react"
import {
  ORGANIZATION_VOLUNTEER_ROLE,
  PARTNER_ADMIN_ROLE,
} from "../../helpers/staffRoleHelpers"

export function useQuickActionsMenu({ staffRole, navigate, menuItemTemplate }) {
  const intakeQuickActionItems = useMemo(() => {
    const items = []

    if (
      staffRole < PARTNER_ADMIN_ROLE &&
      staffRole !== ORGANIZATION_VOLUNTEER_ROLE
    ) {
      items.push({
        label: "New Intake Session",
        // icon: "person_add",
        command: () => navigate("/form/intake_session/1"),
        template: menuItemTemplate,
      })
    }

    if (staffRole < PARTNER_ADMIN_ROLE) {
      items.push({
        label: "New Group Session",
        // icon: "groups",
        command: () => navigate("/form/group_session/1"),
        template: menuItemTemplate,
      })
    }

    return items
  }, [menuItemTemplate, navigate, staffRole])

  const quickActionsMenuItem = useMemo(
    () => ({
      label: "Quick Actions",
      icon: "flash_on",
      className: "nav-quick-actions-item",
      template: menuItemTemplate,
      items: [...intakeQuickActionItems].sort((a, b) =>
        (a?.label || "").localeCompare(b?.label || "", undefined, {
          sensitivity: "base",
        }),
      ),
    }),
    [intakeQuickActionItems, menuItemTemplate],
  )

  return {
    quickActionsMenuItem,
  }
}
